module.exports = __webpack_public_path__ + "img/feat-mobilize-your-loyalty-program.3c8b401f.svg";